<div>
  <div class="banner-imgs">
    <ngb-carousel *ngIf="banner.length > 0">
      <ng-template ngbSlide *ngFor="let b of banner">
        <div class="img-box" [style.backgroundImage]="'url('+ b.url +')'"></div>
        <!-- <img [src]="b.url" class="d-block w-100"> -->
        <div class="carousel-caption">
          <h1>{{ b.title | translate }}</h1>
          <p>{{ b.caption | translate }}</p>
          <a class="btn-animation" (click)="goRegister()">
            <span class="arrow">
              <span></span>
            </span>
            {{ 'GetStarted' | translate }}
          </a>
        </div>
      </ng-template>
    </ngb-carousel>
  </div>
  <div class="bg-grey">
    <div class="intro-1 container">
      <div class="row">
        <div class="text-center col-12" style="margin-bottom: 50px;">
          <img alt="{{'VisionandMission' | translate}}" class="img-fluid " src="/assets/theme/resources/images/landing-page/banner-4.jpg"
            style="max-height: 100%;">
        </div>
      </div>
      <div class="row">
        <div class="content-left col-md-6">
          <h5 class="title-line">{{ 'WhatWeDo' | translate }}</h5>
          <h4 class="title-content">{{ 'TitleIntro1' | translate }}</h4>
          <div>
            <div class="intro-item">
              <span class="icon icon-intro-1"></span>
              <p>{{ 'Intro1' | translate }}</p>
            </div>
            <div class="intro-item">
              <span class="icon icon-intro-2"></span>
              <p>{{ 'Intro2' | translate }}</p>
            </div>
            <div class="intro-item">
              <span class="icon icon-intro-3"></span>
              <p>{{ 'Intro3' | translate }}</p>
            </div>
          </div>
          <a class="btn-animation ml-90" (click)="goRegister()">
            <span class="arrow">
              <span></span>
            </span>
            {{ 'GetStarted' | translate }}
          </a>
        </div>
        <div class="content-right col-md-6 mt-4 mt-sm-0">
          <!-- <img src="/assets/theme/resources/images/landing-page/img-01.png" class="img-fluid"> -->
          <!-- <img *ngIf="imgSrc!=={}" [src]="imgSrc.img1" class="img-fluid" /> -->
          <div *ngIf="imgSrc!=={}" class="img-box bg-no-repeat bg-contain h-100 bg-center"
            [style.backgroundImage]="'url('+ imgSrc.img1 +')'"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="intro-2 container">
    <div class="row m-flex-column-reverse">
      <div class="content-left col-md-6">
        <!-- <img *ngIf="imgSrc!=={}" [src]="imgSrc.img2" class="img-fluid" /> -->
        <div *ngIf="imgSrc!=={}" class="img-box bg-no-repeat bg-contain h-100 bg-center"
          [style.backgroundImage]="'url('+ imgSrc.img2 +')'"></div>
        <!-- <img src="/assets/theme/resources/images/landing-page/img-02.png" class="img-fluid"> -->
      </div>
      <div class="content-right col-md-6 mt-4 mt-sm-0">
        <h5 class="title-line">{{ 'WhatWeDo' | translate }}</h5>
        <h4 class="title-content">{{ 'TitleIntro2' | translate }}</h4>
        <div>
          <div class="intro-item">
            <span class="icon icon-intro-4"></span>
            <p>{{ 'Intro4' | translate }}</p>
          </div>
          <div class="intro-item">
            <span class="icon icon-intro-5"></span>
            <p>{{ 'Intro5' | translate }}</p>
          </div>
          <div class="intro-item">
            <span class="icon icon-intro-6"></span>
            <p>{{ 'Intro6' | translate }}</p>
          </div>
        </div>
        <a class="btn-animation ml-90" (click)="goRegister()">
          <span class="arrow">
            <span></span>
          </span>
          {{ 'GetStarted' | translate }}
        </a>
      </div>
    </div>
  </div>
  <div class="slider-brand container">
    <h4 class="title-content row justify-content-center">{{ 'ParticipatingCarriers' | translate }}</h4>
    <!-- <div class="content-slider row">
      <div class="brand-item col-6 mb-2 col-lg-3 text-center">
        <img class="img-fluid" src="/assets/theme/resources/images/landing-page/logo/1.png">
        <img class="img-fluid" src="/assets/theme/resources/images/landing-page/logo/1-hover.png" class="img-hover">
      </div>
      <div class="brand-item col-6 mb-2 col-lg-3 text-center">
        <img class="img-fluid" src="/assets/theme/resources/images/landing-page/logo/2.png">
        <img class="img-fluid" src="/assets/theme/resources/images/landing-page/logo/2-hover.png" class="img-hover">
      </div>
      <div class="brand-item col-6 mb-2 col-lg-3 text-center">
        <img class="img-fluid" src="/assets/theme/resources/images/landing-page/logo/3.png">
        <img class="img-fluid" src="/assets/theme/resources/images/landing-page/logo/3-hover.png" class="img-hover">
      </div>
      <div class="brand-item col-6 mb-2 col-lg-3 text-center">
        <img class="img-fluid" src="/assets/theme/resources/images/landing-page/logo/4.png">
        <img class="img-fluid" src="/assets/theme/resources/images/landing-page/logo/4-hover.png" class="img-hover">
      </div>
    </div> -->

    <div class="swiper-container swiper-supplier">
      <div class="swiper-wrapper">
        <ng-container *ngFor="let slide of slides; let index=index">
          <div class="swiper-slide">
            <img alt="company logo of supplier" src="/assets/theme/resources/images/landing-page/supplier/{{index+1}}.png"
              style="display: block; width: 100%;">
          </div>
        </ng-container>
      </div>
      <div class="supplier-swiper-button supplier-swiper-button-next"></div>
      <div class="supplier-swiper-button supplier-swiper-button-prev"></div>
    </div>

    <div class="pricing">
      <h4 class="title-content text-center">
        <a routerLinkActive="active" routerLink="/how-it-works">
          {{ 'PricingAndOperations' | translate }}</a>
      </h4>
      <div class="content-pricing">
        <div class="buyer">
          <p>{{ 'CaptionBuyers' | translate }}</p>
          <button class="btn" (click)="goForBuyer()">{{ 'Buyers' | translate }}</button>
        </div>
        <div class="carrier">
          <p>{{ 'CaptionCarriers' | translate }}</p>
          <button class="btn" (click)="goForCarrier()">{{ 'Carriers' | translate }}</button>
        </div>
      </div>
    </div>
  </div>